import { Button, Form, Select } from "antd";
import { getButtonDisabled } from "../../../utilities/helpers";
import get from "lodash/get";
import map from "lodash/map";
import find from "lodash/find";

const HeaderSelector = ({
  config,
  filter,
  form,
  getCompanyTemplates,
  setFilters,
  setConfig,
}) => {
  return (
    <div className="justify-end flex items-center h-full space-x-5 ">
      <Form.Item name="Company" label="Company" colon={false} layout="vertical">
        <Select
          style={{ minWidth: 250 }}
          size="middle"
          value={get(filter, "company")}
          placeholder="Select Company"
          optionFilterProp="label"
          showSearch
          options={map(get(config, "companies"), (company) => ({
            label: get(company, "name"),
            value: get(company, "id"),
          }))}
          onChange={(val) => {
            const company = find(get(config, "companies"), ["id", val]);
            setFilters({
              ...filter,
              templateType: undefined,
              company,
            });
            setConfig({
              ...config,
              templates: get(company, "template_access_list"),
            });
            form.setFieldsValue({
              template: undefined,
            });
          }}
        />
      </Form.Item>
      <Form.Item
        name="template"
        label="Template"
        colon={false}
        layout="vertical"
      >
        <Select
          style={{ minWidth: 250 }}
          size="middle"
          placeholder="Select Template"
          options={map(get(config, "templates"), (template) => ({
            label: get(template, "name"),
            value: get(template, "value"),
          }))}
          value={get(filter, "templateType")}
          onChange={(value) => {
            setFilters({
              ...filter,
              templateType: value,
            });
          }}
        />
      </Form.Item>
      <Form.Item name="submit" label=" " colon={false} layout="vertical">
        <Button
          type="primary"
          className="w-60"
          onClick={getCompanyTemplates}
          disabled={getButtonDisabled(filter, ["templateType", "company"])}
        >
          Submit
        </Button>
      </Form.Item>
    </div>
  );
};
export default HeaderSelector